import Notification from '../../../api/Notifications';
import * as types from './mutation-types';

export const index = async ({commit}) => {
    const json = await new Notification().index();

    commit(types.LIST, json);
};

export const show = async ({commit}, id) => {
    const json = await new Notification().show(id);

    commit(types.ITEM, json);

    console.log(json);
    return json;
};

export const destroy = async (context, id) => {
    await new Notification().destroy(id);
};

export default {
    index,
    show,
    destroy,
};



// WEBPACK FOOTER //
// ./src/store/modules/notification/actions.js